import TemplateView from '../TemplateView'

export default class ComponentsList extends TemplateView {
    constructor({
        containerClass = '',
        itemToId = item => item.id,
        itemToState = item => item,
        itemToComponent = item => null
    }) {
        super()

        this.containerClass = containerClass
        this.componentsMap = {}

        this.state = {
            items: []
        }

        this.onStateChanged(({items}, {items: prevItems}) => {
            let needReInit = false
            if (items.length >= prevItems.length) {
                for (let i = 0; i < length; i++) {
                    const item = items[i]
                    const prevItem = prevItems[i]
                    if (prevItem && itemToId(item) !== itemToId(prevItem)) {
                        needReInit = true
                        break
                    }
                }
            } else {
                needReInit = true
            }

            if (needReInit) {
                this.$el.empty()
                this.componentsMap = {}
                items.forEach(item => {
                    const component = itemToComponent(item).init(this.$el)
                    component.setState(itemToState(item))
                    this.componentsMap[itemToId(item)] = component
                })
            } else {
                items.forEach(item => {
                    const id = itemToId(item)

                    let component = this.componentsMap[id]
                    if (!component) {
                        component = itemToComponent(item).init(this.$el)
                        this.componentsMap[id] = component
                    }

                    component.setState(itemToState(item))
                })
            }
        })
    }

    templateHtml() {
        return '<div class="<%=containerClass%>"></div>'
    }
}


// WEBPACK FOOTER //
// ./web/js/util/ComponentsList.js